var map = {
	"./Beetle_01.jpg": 8513,
	"./Beetle_03.jpg": 7733,
	"./Beetle_04.jpg": 9401,
	"./Beetle_antena_27.jpg": 2863,
	"./Beetle_dorsal_05.jpg": 3198,
	"./Beetle_dorsal_06.jpg": 5069,
	"./Beetle_dorsal_07.jpg": 5367,
	"./Beetle_dorsal_09.jpg": 4306,
	"./Beetle_dorsal_13.jpg": 9650,
	"./Beetle_dorsal_14.jpg": 9958,
	"./Beetle_dorsal_15.jpg": 6824,
	"./Beetle_dorsal_16.jpg": 4286,
	"./Beetle_dorsal_17.jpg": 5727,
	"./Beetle_dorsal_18.jpg": 4281,
	"./Beetle_eyes_25.jpg": 6838,
	"./Jorgojo_1_Tribolium confusum.jpg": 4760,
	"./Jorgojo_2.jpg": 7051,
	"./Jorgojo_antena_01.jpg": 7553,
	"./Jorgojo_head_01.jpg": 8715,
	"./Jorgojo_head_03.jpg": 3060,
	"./Jorgojo_head_05.jpg": 1505
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 412;